import { ChangeDetectionStrategy, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { BetBuilderMarket, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { hashCode } from '@frontend/sports/common/core/utils/string';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { DsButton, DsButtonKind } from '@frontend/ui/button';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../../betslip/base/store/state';
import { ExternalBetslipActions } from '../../../../betslip/core/external-betslip-actions';
import { BetBuilderPickId } from '../../../../betslip/core/picks/pick-id';
import { PrecreatedBabTrackingService } from '../../services/precreated-bab-tracking.service';
import { BetBuilderOverlayHeaderComponent } from '../bet-builder-overlay-header/bet-builder-overlay-header.component';

@Component({
    selector: 'ms-betbuilder-edit-pre-created-bab-button',
    templateUrl: 'bet-builder-edit-precreated-bab-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DsButton, SportsThemedButtonDirective, IconCustomComponent, BetBuilderOverlayHeaderComponent],
})
export class BetBuilderEditPrecreatedBABButtonComponent implements OnInit {
    @Input() fixtureId: string;
    @Input() event: EventModel;
    @Input() market: BetBuilderMarket;

    @ViewChild('header') headerTemplate: TemplateRef<any>;
    epcotEnabled = this.epcotConfig.isEnabled;
    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'mgm-4': 'secondary', 'sports-interaction': 'secondary' };

    constructor(
        private store: Store<IBetslipRootState>,
        public sitecore: Sitecore,
        private trackingService: PrecreatedBabTrackingService,
        private epcotConfig: EpcotConfig,
    ) {}

    ngOnInit() {
        this.trackingService.trackAddorEditButtonLoad(this.event.name, this.event.sport.id, this.event.league.id);
    }

    clickHandler(mouseEvent: MouseEvent) {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        const optionId = Math.abs(hashCode(this.market.longIds![0]) + this.event.sportcastId!);

        const betBuilderMarket = {
            id: optionId,
            name: this.market.name,
            nameSign: '',
            option: {
                id: optionId,
                optionPrice: {
                    id: optionId,
                    nativePrice: this.market.option.optionPrice.nativePrice,
                },
            },
        };
        const pickId = new BetBuilderPickId(this.event.id, this.fixtureId, optionId, optionId, optionId);
        const eventData = {
            event: {
                id: this.event.id,
                date: new Date(this.event.startDate),
                name: this.event.name,
            },
            league: {
                id: this.event.league.id,
                name: this.event.league.name,
            },
            region: {
                id: this.event.region.id,
                name: this.event.region.name,
            },
            offerSource: this.event.offerSource,
        };

        this.store.dispatch(
            ExternalBetslipActions.checkPrecreatedBABConversion({
                pickId,
                eventData,
                market: betBuilderMarket,
                eventModel: this.event,
                longId: this.market.longIds!,
                headerTemplate: this.headerTemplate,
            }),
        );

        if (this.sitecore.betBuilderEntainUI.messages) {
            this.trackingService.trackAddorEditClick(
                this.event.name,
                this.event.sport.id,
                this.event.league.id,
                this.sitecore.betBuilderEntainUI.messages.EditPickButton,
            );
        }
    }
}
